<template>
    <span v-if="displayBagdes" class="language-badge-container" @click.prevent="onClick">
        <span v-if="languages != null && languages.length > 0" v-for="language in sortedLanguages" :key="language" :class="['badge', 'language-badge']">
            <span class="name">{{language.code}}</span>
        </span>
        <span v-else class="placeholder">Languages</span>
    </span>
    <input v-else type="text" readonly placeholder="Languages" :value="languageString"  :class="!languageString || languageString.length === 0 ? 'is-empty' : ''" @click.prevent="onClick"/>
</template>

<script>
    export default {
        name: "LanguageBadgeList",
        props: {
            languages: [Array, String],
            displayBagdes: { type:Boolean, default:false }
        },
        computed: {
            sortedLanguages() {
                if (this.languages === null) return [];
               
                return this.languages && this.languages.sort(function (a, b) {
                    if (a.displayOrder === b.displayOrder) return 0;
                    if (a.displayOrder > b.displayOrder) return 1;
                    return -1;
                });

            },
            languageString() {
                let artNames = this.sortedLanguages && this.sortedLanguages.map(x => x.code);
                return artNames && artNames.join(', ');
            }
        },
         methods: {
            onClick(event) { this.$emit("click", event); }
        }
    }
</script>

<style scoped>
    .language-badge-²tainer {
        white-space: nowrap;
        text-overflow: ellipsis;
        border-bottom: 1px solid #d2d2d2;
        height: 30px;
        display: block;
    }

        .language-badge-container:hover {
            border-bottom: 1px solid #18B9E7;
            cursor: pointer;
        }

    .language-badge {
        background: #18B9E7;
        border-radius: 100px;
        display: -webkit-inline-box;
        display: -ms-inline-flexbox;
        display: inline-flex;
        padding: 5px 10px;
        color: white;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        margin: 0 5px;
    }

        .language-badge.hidden {
            background: #d2d2d2;
        }

        .language-badge .name {
            width: 100%;
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 0 1em;
        }
    input[type=text] {
        text-overflow: ellipsis;
        cursor: pointer;
    }

        input [type=text]:focus {
            background: transparent;
        }
    .placeholder {
        color:#d2d2d2;
    }
</style>
